'use client';
import { useState } from 'react';

type CICheckbox = {
  onClick?: () => void;
  label?: string | React.ReactNode;
  size?: string;
  containerClass?: string;
  defaultValue?: boolean;
};

export const CICheckbox: React.FC<CICheckbox> = ({
  onClick,
  label,
  size = 'lg:size-6 size-5',
  containerClass = '',
  defaultValue = false,
}: CICheckbox) => {
  const [isChecked, setIsChecked] = useState(defaultValue);

  const toggleCheckbox = () => {
    setIsChecked(!isChecked);
    onClick && onClick();
  };

  return (
    <div
      className="flex gap-2"
      role="button"
      tabIndex={0}
      onClick={toggleCheckbox}
    >
      <div
        className={`flex items-center justify-center shrink-0 ${size} rounded cursor-pointer overflow-hidden ${
          isChecked ? 'bg-primary-800' : 'bg-transparent border border-gray-400'
        } select-none ${containerClass}`}
      >
        <span className="material-symbols-outlined text-white">
          {isChecked ? 'check' : ''}
        </span>
      </div>
      {!!label && (
        <p className="font-medium text-gray-700 text-xs md:text-sm">{label}</p>
      )}
    </div>
  );
};
